import { Avatar, Box, Link, SxProps, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GoLeft } from 'Images';
import { TypographyVariants } from 'ThemeV2.0';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface ILinkArrowLeft {
  text: string;
  href?: string;
  sx?: SxProps;
  imgSx?: SxProps;
  newWindow: boolean;
  variant?: TypographyVariants;
  customIcon?: string;
  onClick?: () => void;
  textSx?: SxProps;
  inlineWithText?: boolean;
}

export const LinkArrowLeft2 = ({
  text,
  href = '',
  sx,
  imgSx,
  newWindow,
  variant,
  customIcon,
  onClick,
  textSx,
  inlineWithText,
}: ILinkArrowLeft) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault();
      onClick();
      return;
    }
    if (newWindow) {
      window.open(href, '_blank');
    } else {
      navigate(href);
    }
  };

  if (inlineWithText) {
    return (
      <Link
        href={onClick ? '#' : href}
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={onEnterOrEscapeKeyDown}
        underline='hover'
        sx={{
          display: 'inline',
          verticalAlign: 'baseline',
          ...sx,
        }}
      >
        <Typography
          component='span'
          variant={variant ?? 'body5'}
          color='primary'
          sx={textSx}
        >
          {text}
        </Typography>
        <Box
          alt=''
          component='img'
          src={customIcon || GoLeft}
          sx={{
            display: 'inline-block',
            verticalAlign: 'text-bottom',
            marginInlineStart: '4px',
            width: '20px',
            height: '20px',
            ...imgSx,
          }}
        />
      </Link>
    );
  }

  return (
    <Link
      href={onClick ? '#' : href}
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={onEnterOrEscapeKeyDown}
      underline='hover'
      sx={{
        width: 'max-content',
        display: 'flex',
        alignItems: 'center',
        ...sx,
      }}
    >
      <Typography variant={variant ?? 'body5'} color='primary' sx={textSx}>
        {text}
      </Typography>
      <Avatar
        alt={''}
        src={customIcon || GoLeft}
        sx={{
          width: '20px',
          height: '20px',
          ...imgSx,
        }}
      />
    </Link>
  );
};
